import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  accessToken: string | null;
  isBootstrapping: boolean;
}

const initialState: AuthState = {
  accessToken: null,
  isBootstrapping: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessToken(state, action: PayloadAction<string | null>) {
      state.accessToken = action.payload;
      state.isBootstrapping = false;
    },

    setAuthBootstrapping(state, action: PayloadAction<boolean>) {
      state.isBootstrapping = action.payload;
    },

    logout(state) {
      state.accessToken = null;
    },
  },
});

export const { setAccessToken, setAuthBootstrapping, logout } = authSlice.actions;
export default authSlice.reducer;
